module.exports = __webpack_public_path__ + "static/media/calendar-circle.13374440.svg";